/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';

import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import blue from '@material-ui/core/colors/blue';

import styled from 'styled-components';

import RenderTextField from '../../../utils/renderFields/RenderTextField';
import RenderPinField from '../../../utils/renderFields/RenderPinField';
import Terms from '../../signin/Terms';
import submit from './submit';

const ActionLink = styled.div`
  text-align: center;
  margin-top: 30px;
  color: ${blue[500]};
  cursor: pointer;
  outline: none;
`;

const ConfirmationCodeTitle = styled.p`
  text-align: center;
  margin-bottom: 0;
  margin-top: 30px;
  font-size: 1.2em;
  font-weight: 300;
`;

const useStyles = makeStyles(theme => ({
  '@global': {
    body: {
      backgroundColor: theme.palette.common.white
    }
  },
  paper: {
    marginTop: theme.spacing(15),
    padding: '20px 40px 40px 40px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1)
  },
  submit: {
    margin: theme.spacing(3, 0, 2)
  }
}));

/* eslint-disable import/no-mutable-exports */
let Invitation = ({ handleSubmit, history }) => {
  const classes = useStyles();
  return (
    <form className={classes.form} onSubmit={handleSubmit(submit)} noValidate>
      <Field
        name="email"
        id="email-invitaion-form"
        label="Email"
        fullWidth
        component={RenderTextField}
      />
      <ConfirmationCodeTitle style={{ textAlign: 'center' }}>
        Code d&lsquo;invitation
      </ConfirmationCodeTitle>
      <Field
        name="confirmationCode"
        id="confirmation-code"
        component={RenderPinField}
        autoFocus
        autoComplete="tel"
      />

      <Terms />
      <Button
        type="submit"
        fullWidth
        variant="contained"
        color="primary"
        className={classes.submit}
      >
        Se connecter
      </Button>
      <ActionLink
        role="link"
        tabIndex="0"
        onClick={() => {
          history.push('/signin');
        }}
      >
        Connexion
      </ActionLink>
      <Grid container>
        <Grid item xs />
        <Grid item />
      </Grid>
    </form>
  );
};

Invitation = reduxForm({
  form: 'professionalSingupForm'
})(Invitation);

Invitation.propTypes = {
  handleSubmit: PropTypes.func,
  history: PropTypes.object.isRequired
};

export default withRouter(Invitation);
